import { isEqual, isNullOrBlank, OptionsGetOne, optionsGetOneDefault, toJson } from '../../Commons';
import { InvestUnitEntity } from '../../Entities/Invest.Unit.Entity';
import { SmartDBApi } from '../index.exports';
import { fetchWrapper } from '../../lib/index.exports';

export class InvestUnitApi extends SmartDBApi {
    protected static _Entity = InvestUnitEntity;

    // #region api

    public static async getByFundPolicy_CSApi<T extends InvestUnitEntity>(fundPolicy_CS: string, optionsGet?: OptionsGetOne): Promise<T | undefined> {
        try {
            if (isNullOrBlank(fundPolicy_CS)) {
                throw `fundPolicy_CS not defined`;
            }
            //-------------------------
            let response;
            if (isEqual(optionsGet, optionsGetOneDefault)) {
                response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/by-CS/${fundPolicy_CS}`);
            } else {
                const body = toJson(optionsGet);
                //-------------------------
                response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/by-CS/${fundPolicy_CS}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - getByFundPolicy_CSApi - response OK`);
                const instance = this._Entity.fromPlainObject<T>(data);
                console.log(`[${this._Entity.className()}] - getByFundPolicy_CSApi - fundPolicy_CS: ${fundPolicy_CS} - Instance: ${instance.show()}`);
                return instance;
            } else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - getByFundPolicy_CSApi - fundPolicy_CS: ${fundPolicy_CS} - Instance not found`);
                return undefined;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        } catch (error) {
            console.log(`[${this._Entity.className()}] - getByFundPolicy_CSApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api
}
